import React from "react";
import { CertificateComponent } from "./certificate.component";
import { SectionTitleComponent } from "../../../components/section-title.component";

interface ICertificationsContainerComponentProps {}

export const CertificationsContainerComponent: React.FC<
    ICertificationsContainerComponentProps
> = (props: ICertificationsContainerComponentProps) => {
    const section = {
        title: "Certifications",
        subTitle: "Our Commitment to Quality and Compliance",
        certificates: [
            {
                name: "Cert Information Security Management System",
                delay: "100",
                url: "/assets/img/certs/iso-information-security-management-system.jpg",
            },
            {
                name: "Cert Quality Management System",
                delay: "200",
                url: "/assets/img/certs/iso-quality-management-system.jpg",
            },
            {
                name: "cert3",
                delay: "300",
                url: "/assets/img/certs/nasscom.jpg",
            },
            {
                name: "cert4",
                delay: "400",
                url: "/assets/img/certs/cert4.jpg",
                visible: false,
            },
            {
                name: "cert5",
                delay: "500",
                url: "/assets/img/certs/cert5.jpg",
                visible: false,
            },
            {
                name: "cert6",
                delay: "600",
                url: "/assets/img/certs/cert6.jpg",
                visible: false,
            },
            {
                name: "cert7",
                delay: "700",
                url: "/assets/img/certs/cert7.jpg",
                visible: false,
            },
            {
                name: "cert8",
                delay: "800",
                url: "/assets/img/certs/cert8.jpg",
                visible: false,
            },
        ],
    };

    return (
        <section
            id="certifications"
            className="pricing section light-background"
        >
            <SectionTitleComponent
                title={section.title}
                subTitle={section.subTitle}
            />

            <div className="container">
                <div className="row gy-4">
                    {section.certificates.map((certificate) => (
                        <CertificateComponent
                            url={certificate.url}
                            delay={certificate.delay}
                            key={certificate.name}
                            name={certificate.name}
                            visible={certificate.visible}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};
